<template>
	<div>
		<canvas id="my-component-hdchart"
		        ref="hdchart"
		        @mousemove="move($event)"
		        @mousedown="down($event)">您的设备不支持canvas</canvas>
		{{points}}
	</div>
</template>

<script>
import Chart from './EHchart.js';
import guid from './core/guid.js';

var chart = null;//Chart实例
/*
* 频率控制 返回函数连续调用时，fn 执行频率限定为每多少时间执行一次
* @param fn {function}  需要调用的函数
* @param delay  {number}    延迟时间，单位毫秒
* @param immediate  {bool} 给 immediate参数传递false 绑定的函数先执行，而不是delay后后执行。
* @return {function}实际调用函数
*/
function throttle(fn, delay, immediate, debounce) {
	var curr = +new Date(),//当前事件
		last_call = 0,
		last_exec = 0,
		timer = null,
		diff, //时间差
		context,//上下文
		args,
		exec = function () {
			last_exec = curr;
			fn.apply(context, args);
		};
	return function () {
		curr = +new Date();
		context = this,
			args = arguments,
			diff = curr - (debounce ? last_call : last_exec) - delay;
		clearTimeout(timer);
		if (debounce) {
			if (immediate) {
				timer = setTimeout(exec, delay);
			} else if (diff >= 0) {
				exec();
			}
		} else {
			if (diff >= 0) {
				exec();
			} else if (immediate) {
				timer = setTimeout(exec, -diff);
			}
		}
		last_call = curr;
	}
};

/*
* 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 delay，fn 才会执行
* @param fn {function}  要调用的函数
* @param delay   {number}    空闲时间
* @param immediate  {bool} 给 immediate参数传递false 绑定的函数先执行，而不是delay后后执行。
* @return {function}实际调用函数
*/

function debounce(fn, delay, immediate) {
	return throttle(fn, delay, immediate, true);
};

function Point(id, option) {
	this.id = id
	this.name = option.name || '';
	this.mark = option.mark || '';
	this.value = option.value || {};
	this.position = option.position || [0, 0];
	this.checked = option.checked || false;
	this.scolor = option.scolor || 'red';
	this.fcolor = option.fcolor || 'black';
	this.width = option.width || '1';
	this.hovercolor = "red"
	this.blurcolor = "green"
	this.isHovering = false
}
Point.prototype = {
	radius: 2,
	rr: this.radius * this.radius,// radius squared
	draw: function (ctx) {
		var x = chart.d2x(this.value.d * 1000);
		var y = chart.dh2y(this.value.d * 1000, this.value.h)
		if (this.mark) {
			ctx.font = '1em Vijaya'
			ctx.strokeStyle = 'black';
			ctx.lineWidth = 1;
			ctx.strokeText(this.mark, x - 10, y - 10);
		}
		ctx.strokeStyle = this.scolor;
		ctx.lineWidth = this.width;
		ctx.beginPath();

		ctx.arc(x, y, this.radius, 0, 2 * Math.PI);
		ctx.stroke();
		ctx.fill();
		// if(point.checked)ctx.fill();
	}
}


export default {
	name: 'my-component-hdchart',
	props: {
		configure: {
			required: true
		},
		curstatus: { required: true },
		curline: { required: true },
		curmethod: { required: true },
	},
	data: function () {
		return {
			canvas: null,
			ctx: null,
			chart: null,
			img: null,
			x: 0, y: 0,//当前x,y
			event: {},
			points: [],
			lines: []
		}
	},
	mounted: function () {
		this.canvas = this.$refs.hdchart;
		this.refleshCanvas();//这个不需要延时了
	},
	watch: {
		'configure.isreflesh': {
			handler: function (val, oldVal) {
				console.log('configure:', val, oldVal)
				//应该更新底图了(复杂方法是，父组件通过ref得到子组件，然后触发$emit(refresh)方法，子组件内实现该方法的监听)
				if (val) {
					this.updateCanvas();
					this.configure.isreflesh = false;//重置为false
				}
			},
			deep: true
		},
		'configure.hiddenimg': function (val) {
			this.updateTooltip();
		},
		'configure.hiddensummberres': function (val) {
			this.updateTooltip();
		},
		'configure.hiddenwinterres': function (val) {
			this.updateTooltip();
		},
		'configure.transparency': function (val) {
			this.updateTooltip();
		},
		'configure.toolTipsParm': {
			handler: function (val) {
				this.updateTooltip();
			},
			deep: true
		},

		curstatus: {
			handler: function (val, oldVal) {
				// console.log('curstatus',val,oldVal)
				// 这里应该更新tooltip
				this.updateTooltip();
			},
			deep: true
		},
		curmethod: {
			handler: function (val, oldVal) {
				// this.curmethod=val;
				// console.log('curMethod',val,oldVal)
				// 这里应该更新tooltip
				this.updateTooltip();
			},
			deep: true
		},
	},
	methods: {
		//延时更新底图
		updateCanvas: debounce(function () {
			this.refleshCanvas();
		}, 100, true),
		updateTooltip: debounce(function () {
			this.refleshTooltip();
		}, 100, true),
		refleshCanvas: function () {
			this.canvas.width = this.configure.width;
			this.canvas.height = this.canvas.width * 0.618;
			this.configure.height = this.canvas.height;//这个必须要设置

			this.ctx = this.canvas.getContext('2d');
			if (!this.ctx) { alert('您的设备不支持canvas') }
			//为ctx增加绘制电话线的函数
			this.ctx.constructor.prototype.drawDashLine = function (x1, y1, x2, y2, dashLength) {
				var dashLen = dashLength === undefined ? 5 : dashLength,
					xpos = x2 - x1, //得到横向的宽度;
					ypos = y2 - y1, //得到纵向的高度;
					numDashes = Math.floor(Math.sqrt(xpos * xpos + ypos * ypos) / dashLen);
				this.beginPath();
				//利用正切获取斜边的长度除以虚线长度，得到要分为多少段;
				for (var i = 0; i < numDashes; i++) {
					if (i % 2 === 0) {
						this.moveTo(x1 + (xpos / numDashes) * i, y1 + (ypos / numDashes) * i);
						//有了横向宽度和多少段，得出每一段是多长，起点 + 每段长度 * i = 要绘制的起点；
					} else {
						this.lineTo(x1 + (xpos / numDashes) * i, y1 + (ypos / numDashes) * i);
					}
				}
				this.stroke();
			}
			chart = this.chart = new Chart(this.configure);
			this.img = this.chart.createImg();
			this.refleshTooltip();
			this.$emit('canvasrefleshed');
		},
		refleshTooltip: function () {
			var ctx = this.ctx;
			var chart = this.chart;
			//1.清空画布
			ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			//2.绘制背景图片
			ctx.globalAlpha = this.configure.transparency;//透明度
			if (!this.configure.hiddenimg) ctx.drawImage(this.img, 0, 0);
			ctx.globalAlpha = 1;
			//3.
			if (!this.configure.hiddentooltip) {
				chart.drawToolTip(ctx, this.x, this.y, this.configure.toolTipsParm.StrokeColor, this.configure.toolTipsParm.TextColor);
			}

			//console.log('curMethod',this.curmethod)
			var toolTipsParm = this.configure.toolTipsParm;
			if (this.curmethod) {
				if (!this.configure.hiddensummberres) {
					this.curmethod.outputSummberRes.Points.forEach(function (p) {
						chart.drawStatus(ctx, p.value, '', toolTipsParm.StatusColor, 1)
					})
					this.curmethod.outputSummberRes.Lines.forEach(function (l) {
						chart.drawLine(ctx, l.p1.value, l.p2.value, '', toolTipsParm.LineColor, 1)
					})
				}

				if (!this.configure.hiddenwinterres) {
					this.curmethod.outputWinterRes.Points.forEach(function (p) {
						chart.drawStatus(ctx, p.value, '', toolTipsParm.StatusColor, 1)
					})
					this.curmethod.outputWinterRes.Lines.forEach(function (l) {
						chart.drawLine(ctx, l.p1.value, l.p2.value, '', toolTipsParm.LineColor, 1)
					})
				}
			}
			//console.log(this.curstatus)
			if (this.curstatus && this.curstatus.isActive) chart.drawStatus(ctx, this.curstatus.value, this.curstatus.mark, toolTipsParm.StatusColor, 3)
			if (this.curline && this.curline.isActive) {
				chart.drawLine(ctx, this.curline.p1.value, this.curline.p2.value, this.curline.mark, toolTipsParm.LineColor, 2)
				chart.drawStatus(ctx, this.curline.p1.value, this.curline.p1.mark, toolTipsParm.StatusColor, 3)
				chart.drawStatus(ctx, this.curline.p2.value, this.curline.p2.mark, toolTipsParm.StatusColor, 3)
			}
			this.points.forEach((item) => {
				item.draw(ctx)
			})

		},
		//http://stackoverflow.com/questions/20651385/hover-to-change-color-of-canvas
		//事件判断
		move: function (event) {
			if (event.type == "mousemove") {
				this.x = event.layerX;
				this.y = event.layerY;
			} else if (event.type == "pan") {
				this.x = event.center.x;
				this.y = event.center.y;
			}
			this.updateTooltip();//这个会延迟
		},
		down: function (event) {
			if (event.type == "mousedown") {
				this.x = event.layerX;
				this.y = event.layerY;
			} else if (event.type == "tap") {
				this.x = event.center.x;
				this.y = event.center.y;
			}

			var res = this.chart.getRes(this.ctx, this.x, this.y)
			if (!res) return;//如果不再区域内，返回
			this.curstatus.isActive = true;
			this.curstatus.mark = 'i';
			this.curstatus.value.t = res.t;
			this.curstatus.value.tw = res.tw;
			this.curstatus.value.td = res.td;
			this.curstatus.value.h = res.h;
			this.curstatus.value.d = res.d;
			this.curstatus.value.rh = res.rh;
			this.curstatus.value.pv = res.pv;
			var tempp = new Point(guid(), { name: 'p', value: res, position: [this.x, this.y] })
			// var tempp = Object.assign(pointObject, { name: '', value: res, position: [this.x, this.y] })
			this.points.push(tempp)
		},
		ceshi: function (e) {
			e.preventDefault()
			console.log(e)
			this.event = e;
			console.log('scrollLeft:', e.target.scrollLeft);
			//scrollTop:
		}
	}
}

</script>

<style>

</style>


// WEBPACK FOOTER //
// index.vue?ec2d0d3e